import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const EditPenIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M15.4009 4.59906C14.8244 4.02254 13.8897 4.02254 13.3132 4.59906L12.6776 5.23466L14.7653 7.32244L15.4009 6.68684C15.9775 6.11031 15.9775 5.17558 15.4009 4.59906ZM16.5795 7.86535C17.8069 6.63795 17.8069 4.64795 16.5795 3.42055C15.3521 2.19315 13.3621 2.19315 12.1347 3.42055L3.15237 12.4028C3.01857 12.5366 2.93428 12.712 2.91339 12.9001L2.5051 16.5746C2.47715 16.8262 2.56508 17.0769 2.74408 17.2559C2.92309 17.4349 3.17376 17.5229 3.42537 17.4949L7.09994 17.0866C7.28801 17.0657 7.46336 16.9814 7.59717 16.8476L16.5795 7.86535ZM13.5868 8.50095L11.4991 6.41317L4.53758 13.3746L4.27661 15.7234L6.62536 15.4624L13.5868 8.50095Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

EditPenIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(EditPenIcon);
